import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Header_packages from "../components/Header_packages";
import { useLoading } from "../contexts/LoadingContext";
import { useLocation, useParams } from "react-router-dom";
import Swal from 'sweetalert2'; 
import axios from "axios";
import getInsuranceData from "../modals/getInsuranceData";
import "../../src/style.css";

const mapServiceIdToType = (serviceId) => {

  const typeMap = {
    "1": "mobile",
    "2": "health",
    "3": "bike",
    "4": "crops",
    "5": "car",
    "6": "home",
    "7": "accidental",
  };
  return typeMap[serviceId] || "unknown";
};

const MyActivePackages = () => {
  const location = useLocation();
  const { serviceId } = useParams(); 
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unsubscribing, setUnsubscribing] = useState(false);
  const { isLoading, setIsLoading } = useLoading();
  const decryptedMsisdn = sessionStorage.getItem("decryptedMsisdn") || "";

 
  const insuranceType = mapServiceIdToType(serviceId);

  useEffect(() => {
    console.log("Service ID from URL:", serviceId);
    console.log("Insurance Type determined:", insuranceType);
    console.log("MSISDN from session:", decryptedMsisdn);

    const fetchTransactions = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(
          "https://bankalfalah.webddocsystems.com/smosa.php/checkService",
          { serviceId, msisdn: decryptedMsisdn },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic RE9UVXNlcm5hbWUxOkRPVFBhc3MyMTNAIQ==",
              PartnerId: "partner-a5d477b9-c77c-48d5-b9d0-df2d71370680",
              Accept: "application/json"
            },
          }
        );
        console.log("Transaction Details:", response.data);
        if (response.status === 200 && response.data.responseCode === "100") {
          setTransactionDetails(response.data.message || null);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };

    if (serviceId) {
      fetchTransactions();
    } else {
      console.error("Service ID is missing from the URL.");
    }
  }, [serviceId, insuranceType, setIsLoading]);

  const handleUnsubscribe = async () => {
    const encryptedMsisdn = sessionStorage.getItem("encryptedMsisdn");
    setUnsubscribing(true);
    
    // Fetch insurance data based on the type
    const insuranceData = getInsuranceData(insuranceType);
    console.log("Insurance Data:", insuranceData);
    
    const subscribedPackage = insuranceData.find(
      (item) => item.serviceId === parseInt(transactionDetails.serviceId)
    );
  
    if (!subscribedPackage) {
      Swal.fire({
        icon: 'error',
        title: 'No Matching Package',
        text: 'No matching package found for the subscribed service.',
      });
      setUnsubscribing(false);
      return;
    }
    
    const { pid } = subscribedPackage;
  
    try {
      const response = await axios.post(
        "https://bankalfalah.webddocsystems.com/smosa.php/Unsub",
        { msisdn: decryptedMsisdn, pid },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic RE9UVXNlcm5hbWUxOkRPVFBhc3MyMTNAIQ==",
            PartnerId: "partner-a5d477b9-c77c-48d5-b9d0-df2d71370680",
            Accept: "application/json"
          },
        }
      );
  
      console.log("Unsubscribe Response:", response.data);
  
      if (response.status === 200 && response.data === "SUCCESS") {
        Swal.fire({
          icon: 'success',
          title: 'Unsubscribed',
          text: 'Successfully unsubscribed from the service.',
        }).then(() => {
          // Retrieve msisdn from session storage or wherever it is stored
          const msisdn = sessionStorage.getItem('msisdn'); // Adjust based on your storage method
          // Redirect to home page with msisdn in query params
          window.location.href = `/?msisdn=${encodeURIComponent(encryptedMsisdn)}`;
        });
        setTransactionDetails(null);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed to Unsubscribe',
          text: 'Failed to unsubscribe. Please try again.',
        });
        console.error("Unexpected response during unsubscribe:", response.data);
      }
    } catch (error) {
      console.error("Error unsubscribing:", error.response || error.message);
      Swal.fire({
        icon: 'error',
        title: 'Error Occurred',
        text: 'Error occurred while unsubscribing. Please try again.',
      });
    } finally {
      setUnsubscribing(false);
    }
  };

  return (
    <>
      <Header_packages title="My Packages" />
      <Container className="mt-5">
        <Row style={{ marginBottom: "130px", marginTop: "20px" }}>
          {loading ? (
            <p className="text-center">Loading...</p>
          ) : transactionDetails ? (
            <Col xs={12} md={8} lg={6} className="mx-auto">
              <Card className="shadow border-0 rounded-lg">
                <Card.Body>
                  <div className="d-flex justify-content-between mb-3">
                    <div>
                      <p className="mb-1 heading">MSISDN:</p>
                      <p className="mb-1">{transactionDetails.msisdn}</p>
                      <p className="mb-1 heading">Subscription Date:</p>
                      <p className="mb-1">{transactionDetails.subscriptionDate}</p>
                    </div>
                    <div>
                      <p className="mb-1 heading">Next Renewal Date:</p>
                      <p className="mb-1">{transactionDetails.nextRenewalDate}</p>
                      <p className="mb-1 heading">Bundle Expiry Date:</p>
                      <p className="mb-1">{transactionDetails.bundleExpiryDate || "N/A"}</p>
                    </div>
                  </div>
                  <Button
                    style={{ background: 'linear-gradient(to left, #c84f92, #6b287c)', border: 'black' }} // Custom background color
                    className="w-100"
                    onClick={handleUnsubscribe}
                    disabled={unsubscribing}
                  >
                    {unsubscribing ? "Unsubscribing..." : "Unsubscribe"}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ) : (
            <p className="text-center">No active package available.</p>
          )}
        </Row>
      </Container>
    </>
  );
};

export default MyActivePackages;
